var map = {
	"./add.svg": 24402,
	"./alarm.svg": 79664,
	"./copy.svg": 78838,
	"./delete.svg": 94928,
	"./exitFullScreen.svg": 39294,
	"./financialManagement.svg": 54199,
	"./language.svg": 5247,
	"./list.svg": 99161,
	"./noshow.svg": 11019,
	"./number-check.svg": 74349,
	"./overview.svg": 51692,
	"./person.svg": 85258,
	"./product.svg": 52422,
	"./report.svg": 55239,
	"./settings.svg": 55341,
	"./show.svg": 75426,
	"./sms.svg": 74060,
	"./update.svg": 96974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71525;